import axiosInstance from "../../../configs/axios";

export interface AdminDeal {
  uuid: string;
  companyName: string;
  vatNumber: string;
  partnerVatId?: string;
  partnerCompanyName?: string;
  /** Partner user account that registered the deal. */
  accountName?: string;
  contactPerson: string;
  region: string;
  note?: string;
  services?: string[];
  createdAt: string;
  expiresAt?: string;
  updatedAt: string;
  createdBy?: string;
}

// Admin deals API — reuses the shared /deals endpoints.
// Called with no vatNumber filter, so it returns ALL partners' deals.
export const dealsAPI = {
  getAllDeals: async (): Promise<AdminDeal[]> => {
    const response = await axiosInstance.get("/deals");
    return response.data?.data ?? [];
  },

  extendReservation: async (uuid: string, months: number) => {
    const response = await axiosInstance.patch(`/deals/${uuid}/extend`, {
      months,
    });
    return response.data;
  },
};
